import { Component } from '@angular/core';

@Component({
  selector: 'rdo-equipment',
  templateUrl: 'equipment.component.html',
  standalone: false,
})
export class EquipmentComponent {
  constructor() {}
}
